export function getConfig(p = {}) {

    const { config = {} } = p

    const commonConfig = config.common || {}
    const globalsConfig = config.globals || {}

    const { WAPP, DEV } = globalsConfig

    const common = {
        ...commonConfig,
        lang: 'hu_HU',
        siteName: 'Audrey\'s Home',
        description: 'Üdvözlünk az Audrey\'s Home webáruházban! Carefully crafted and curated design pieces.',
        graphql: {
            route: (DEV) ? '/graphql' : '/g' + WAPP
        }
    }

    return {
        config: {
            ...config,
            common: common
        }
    }
}
